<!-- Notifications toggle -->
<button
    class="relative flex items-center justify-center size-9 rounded-lg border border-white/10 hover:border-white/20 hover:bg-white/[0.06] text-white/60 hover:text-white/90 transition-all duration-150 cursor-pointer"
    (click)="openPanel()"
    #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute -top-1 -right-1 flex items-center justify-center">
            <span class="flex items-center justify-center shrink-0 min-w-[18px] h-[18px] px-1 rounded-full bg-emerald-500 text-white text-[10px] font-semibold ring-2 ring-[#1A1A1A]">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel *transloco="let t">

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-xl overflow-hidden shadow-xl border border-gray-100">

        <!-- Header -->
        <div class="flex shrink-0 items-center h-14 pr-4 pl-5 bg-white border-b border-gray-100">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-gray-500"
                        [svgIcon]="'heroicons_solid:x'"></mat-icon>
                </button>
            </div>
            <div class="text-sm font-semibold text-gray-800">Notifications</div>
            <ng-container *ngIf="unreadCount > 0">
                <span class="ml-2 flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-semibold">
                    {{unreadCount}}
                </span>
            </ng-container>
            <div class="ml-auto">
                <button
                    mat-icon-button
                    class="!size-8 !min-h-[32px]"
                    [matTooltip]="'Mark all as read'"
                    [disabled]="unreadCount === 0"
                    (click)="markAllAsRead()">
                    <mat-icon
                        class="icon-size-4 text-gray-400"
                        [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y divide-gray-50 overflow-y-auto bg-white">
            <!-- Notifications -->
            <ng-container *ngFor="let notification of notifications; trackBy: trackByFn">
                <div
                    class="flex group hover:bg-gray-50 transition-colors duration-100"
                    [ngClass]="{'bg-primary-50/40': !notification.read}">

                    <!-- Notification with a link -->
                    <ng-container *ngIf="notification.link">
                        <!-- Normal links -->
                        <ng-container *ngIf="!notification.useRouter">
                            <a
                                class="flex flex-auto py-4 pl-5 cursor-pointer"
                                [href]="notification.link">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                        <!-- Router links -->
                        <ng-container *ngIf="notification.useRouter">
                            <a
                                class="flex flex-auto py-4 pl-5 cursor-pointer"
                                [routerLink]="notification.link">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                    </ng-container>

                    <!-- Notification without a link -->
                    <ng-container *ngIf="!notification.link">
                        <div class="flex flex-auto py-4 pl-5">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>
                    </ng-container>

                    <!-- Actions -->
                    <div class="relative flex flex-col my-4 mr-5 ml-2">
                        <!-- Indicator -->
                        <button
                            class="w-6 h-6 min-h-6"
                            mat-icon-button
                            (click)="toggleRead(notification)"
                            [matTooltip]="notification.read ? 'Mark as unread' : 'Mark as read'">
                            <span
                                class="block w-2 h-2 rounded-full transition-opacity duration-150"
                                [ngClass]="{
                                    'bg-gray-300 sm:opacity-0 sm:group-hover:opacity-100': notification.read,
                                    'bg-primary-500': !notification.read
                            }"></span>
                        </button>
                        <!-- Remove -->
                        <button
                            class="min-h-6 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity duration-150"
                            (click)="delete(notification)"
                            [matTooltip]="'Remove'">
                            <mat-icon
                                class="icon-size-4 text-gray-400"
                                [svgIcon]="'heroicons_solid:x'"></mat-icon>
                        </button>
                    </div>

                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- Icon -->
                    <ng-container *ngIf="notification.icon && !notification.image">
                        <div class="flex shrink-0 items-center justify-center w-9 h-9 mr-3 rounded-lg bg-primary-50 text-primary-600">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="notification.icon">
                            </mat-icon>
                        </div>
                    </ng-container>
                    <!-- Image -->
                    <ng-container *ngIf="notification.image">
                        <img
                            class="shrink-0 w-9 h-9 mr-3 rounded-lg overflow-hidden object-cover object-center"
                            [src]="notification.image"
                            [alt]="'Notification image'">
                    </ng-container>
                    <!-- Title, description & time -->
                    <div class="flex flex-col flex-auto min-w-0">
                        <ng-container *ngIf="notification.title">
                            <div
                                class="text-sm font-semibold text-gray-800 line-clamp-1"
                                [innerHTML]="notification.title"></div>
                        </ng-container>
                        <ng-container *ngIf="notification.description">
                            <div
                                class="text-sm text-gray-500 line-clamp-2 mt-0.5"
                                [innerHTML]="notification.description"></div>
                        </ng-container>
                        <div class="mt-1.5 text-xs leading-none text-gray-400">
                            {{notification.time | date:'MMM dd, h:mm a'}}
                        </div>
                    </div>
                </ng-template>
            </ng-container>

            <!-- No notifications -->
            <ng-container *ngIf="!notifications || !notifications.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-12 h-12 rounded-xl bg-gray-100">
                        <mat-icon
                            class="text-gray-400 icon-size-6"
                            [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-4 text-base font-semibold text-gray-800">
                        {{t('notifications.no_notifications')}}
                    </div>
                    <div class="w-full max-w-60 mt-1 text-sm text-center text-gray-400">
                        {{t('notifications.no_notifications_description')}}
                    </div>
                </div>
            </ng-container>

        </div>

    </div>

</ng-template>
